var map = {
	"./I-选中.png": "5288",
	"./II-选中.png": "48f6",
	"./III-选中.png": "f0da",
	"./IV-选中.png": "6579",
	"./instantRisk/橙-选中.png": "0064",
	"./instantRisk/红-选中.png": "b637",
	"./instantRisk/绿-选中.png": "9222",
	"./instantRisk/蓝-选中.png": "022b",
	"./instantRisk/黄-选中.png": "f760"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d75";